export function getHashParam(name: string): string {
    const hash = window.location.hash.startsWith("#")
        ? window.location.hash.slice(1)
        : window.location.hash;

    const params = new URLSearchParams(hash);
    return params.get(name) ?? "";
}

export function getHashParamInt(name: string, alternate = 0): number {
    const num = parseInt(getHashParam(name), 10);
    return Number.isNaN(num) ? alternate : num;
}

export function setHashParam(name: string, value: string): void {
    const hash = window.location.hash.startsWith("#")
        ? window.location.hash.slice(1)
        : window.location.hash;

    const params = new URLSearchParams(hash);

    if (value === "") {
        params.delete(name);
    } else {
        params.set(name, value);
    }

    const newHash = params.toString();
    history.replaceState(null, "", `${window.location.pathname}${window.location.search}${newHash ? "#" + newHash : ""}`);
}
